import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';

export function useGetProjectDomainsGq(command: CommandGq) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
  });

  return {
    query,
    data: (query?.data ?? query?.previousData)?.projects?.getProjectDomains,
  };
}

const gqTag = gql`
  query GetProjectDomains($command: GetProjectDomainsCommand!) {
    projects {
      getProjectDomains(command: $command) {
        domains
      }
    }
  }
`;

interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {}

interface GQLData {
  readonly projects: {
    readonly getProjectDomains: ResponseGq;
  };
}

export interface ResponseGq {
  readonly domains: string[];
}
